export default ['$q', 'JsonRPCService', ($q, JsonRPCService) => {
    return {
        changeLicensePlateAndVIN: (policyNumber, vehicleFixedId, licensePlate, vin) => {
            return JsonRPCService.send('pc', 'gatewaypolicychange/policychange', 'changeLicensePlateAndVIN_PSA', [policyNumber, vehicleFixedId, licensePlate, vin]);
        }
    };
}];
